module.exports = __webpack_public_path__ + "img/novelone.aadf48d6.png";